import { render, staticRenderFns } from "./HomeLivingStandards.vue?vue&type=template&id=065b3b42&scoped=true"
import script from "./HomeLivingStandards.vue?vue&type=script&lang=js"
export * from "./HomeLivingStandards.vue?vue&type=script&lang=js"
import style0 from "./HomeLivingStandards.vue?vue&type=style&index=0&id=065b3b42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065b3b42",
  null
  
)

export default component.exports